// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
// Module
exports.push([module.id, ".v-divider.dashed-h,.v-divider.dashed-v{border-style:dashed!important;border-width:3px!important}.v-divider.dashed-h{border-top:0!important}.v-divider.dashed-v{border-left:1!important}", ""]);
// Exports
module.exports = exports;
